// extracted by mini-css-extract-plugin
export default {"formContent":"AddEditLicenseDialogContent_formContent__Kfggt"};